import { render, staticRenderFns } from "./PopupBody.vue?vue&type=template&id=4d513c6c&scoped=true"
import script from "./PopupBody.vue?vue&type=script&lang=ts"
export * from "./PopupBody.vue?vue&type=script&lang=ts"
import style0 from "./PopupBody.vue?vue&type=style&index=0&id=4d513c6c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d513c6c",
  null
  
)

export default component.exports